import * as React from 'react';
import { Link } from '@fluentui/react-components';
import { useHistory } from 'react-router-dom';

// Fluent makes it very difficult to correctly extend/reuse props
// in components like this, so we will just disable the linting on them.
// Type checks are still valid and strict!

/* eslint-disable react/prop-types */

type LinkProps = React.ComponentProps<typeof Link>;

type TextLinkProps = LinkProps & {
  openNewTab?: boolean;
};

export function TextLink(props: TextLinkProps) {
  const isExternalUrl = 'href' in props && /^https?:\/\//.test(props.href!);
  const history = useHistory();

  function handleClick(event: React.MouseEvent<HTMLAnchorElement> & React.MouseEvent<HTMLButtonElement>) {
    if (props.onClick) {
      props.onClick(event);
    }

    if (event.isDefaultPrevented()) {
      return;
    }

    if ('href' in props && props.openNewTab) {
      event.preventDefault();
      window.open(props.href, '_blank');
      return;
    }

    if ('href' in props && !isExternalUrl && !props.download) {
      event && event.preventDefault();
      history.push(props.href as string);
      return;
    }
  }

  return <Link onClick={handleClick} {...props} inline />;
}
